import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./PatientInfoPop.module.scss";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
const PatientInfoPop = ({
  patiendInfo,
  setPatientInfo,
  setPatientInfoData,
  patientinfoData,
  tempPrescription,
  mainPrescription,
  typepres,
  meetingData,
}) => {
  const handlePatientInfo = () => setPatientInfo(!patiendInfo);
  const [patientDataObj, setPatientDataObj] = useState({});
  const userRole = localStorage.getItem("user_login_type_role");
  const params = queryString.parse(window.location.search);
  let location = useLocation();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  console.log(patientinfoData, "pati3211entinfoData");

  const today = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  function formatDate(presDate) {
    const dateObj = new Date(presDate);
    return `${String(dateObj.getDate()).padStart(2, "0")}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${dateObj.getFullYear()}`;
  }
  let presdate = null;

  if (typepres == "prescription" && mainPrescription?.length > 0) {
    presdate = formatDate(mainPrescription?.[0]?.createdAt);
  } else if (typepres == "temp-prescription" && tempPrescription?.length > 0) {
    presdate = formatDate(tempPrescription?.[0]?.createdAt);
  }
  console.log("presdate", presdate);
  console.log(tempPrescription, "tempPres332211cription", mainPrescription);

  return (
    <>
      <Modal
        show={patiendInfo}
        onHide={handlePatientInfo}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        className={`${styles.PatientInfoPop} PatientInfoPop`}
        scrollable="true"
      >
        <Modal.Header
          className={`${styles.header} position-relative`}
          closeButton
        >
          {
            <>
              {" "}
              <Modal.Title className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0">
                {userRole == "4" ||
                params?.isPriestMeeting == "true" ||
                location.pathname.startsWith("/pastoral-summary")
                  ? "Priest Info"
                  : "Doctor Info"}
              </Modal.Title>
              <div className="flex items-center gap-10 ms-auto text-blue">
                Date: {today}
              </div>{" "}
            </>
          }
          {/* {!typepres && (
            <>
              {" "}
              <Modal.Title className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0">
                Patient Info
              </Modal.Title>
              <div className="flex items-center gap-10 ms-auto text-blue">
                Date: {today}
              </div>
            </>
          )} */}
          {/* {typepres && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Modal.Title className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0">
                Doctor Info
              </Modal.Title>
              <p
                className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0"
                style={{ color: "red", marginRight: "44px", fontSize: "24px" }}
              >
                Today's Date: {today}
              </p>
            </div>
          )} */}
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="">
              <Col md="6" className="my-2">
                <label htmlFor="first_name" className="form-label">
                  First Name:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="first_name"
                  value={patientinfoData?.first_name || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="last_name" className="form-label">
                  Last Name:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={patientinfoData?.last_name || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="address" className="form-label">
                  Address:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={patientinfoData?.address || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="city" className="form-label">
                  City:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={patientinfoData?.city || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="state" className="form-label">
                  State:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={patientinfoData?.state || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="country" className="form-label">
                  Country:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="country"
                  value={patientinfoData?.country || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="phone_no" className="form-label">
                  Phone:
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="phone_no"
                  value={patientinfoData?.phone_no || ""}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="email" className="form-label">
                  Email:
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={patientinfoData?.email || ""}
                  onChange={handleInputChange}
                />
              </Col>
              {/* {userRole !== "4" && userRole !== "1" && (
                <Col md="6" className="my-2">
                  <label htmlFor="" className="form-label">
                    License:
                  </label>
                  <input
                    readOnly
                    value={patientinfoData?.license_no || ""}
                    type="text"
                    className="form-control "
                  />
                </Col>
              )} */}
              {
                <Col
                  md="6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                  className="flex"
                >
                  <p
                    className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0 "
                    style={{
                      color: "red",
                      marginRight: "44px",
                      fontSize: "24px",
                    }}
                  >
                    {userRole == "4" || params?.isPriestMeeting == "true"
                      ? "Report"
                      : "Prescription"}{" "}
                    Date: {presdate ? presdate : "N/A"}
                  </p>
                </Col>
              }
            </Row>
            <Row className=""></Row>
          </Form>
          {/* <div className="d-flex justify-content-center mt-4">
            <button
              onClick={handlePatientInfo}
              className="submit-btn d-inline-flex  justify-content-center"
              style={{ maxWidth: "max-content" }}
            >
              Save
            </button>
          </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PatientInfoPop;
